export const PRODUCT_SPECIFICATIONS = 'product-specifications'
export const PRODUCT_DETAILS_SECTION_ID = 'product-details'
export const REVIEWS_SECTION_ID = 'review-card'
export const GUIDES_SECTION_ID = 'guides-section'

export const ROUTES = {
  HOME: '/',
  PRODUCT: `/products`,
  PRODUCT_SPECIFICATIONS,
  REVIEWS_SECTION_ID,
  GUIDES_SECTION_ID,
  PRODUCT_DETAILS_SECTION_ID,
  PRODUCT_REVIEWS: (slug: string) => `/products/${slug}#${REVIEWS_SECTION_ID}`,
  PRODUCT_DETAILS: (slug: string) => `/products/${slug}#${PRODUCT_DETAILS_SECTION_ID}`,
  TAGS: (filter: string | []) => `/products?category=${filter}`,
  CHECKOUT: '/checkout',
  CHECKOUT_PAYMENTS: '/checkout/payments',
  CONTACT: '/contact-us',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  FAQ: '/faq',
  FORGET_PASSWORD: '/forget-password',
  CHANGE_PASSWORD: '/my-account/change-password',
  ACCOUNT: '/my-account',
  ACCOUNT_SETTINGS: '/my-account/account-settings',
  ADDRESS: '/my-account/address',
  PAYMENT: '/my-account/payment',
  HELP_CENTER: '/my-account/help-center',
  LEGAL_NOTICE: '/my-account/legal-notice',
  NOTIFICATION: '/my-account/notification',
  SHOPS: '/shops',
  LOGIN: '/sign-in',
  SEARCH: '/search',
  PRODUCTS: '/products',
  CATEGORY: '/category',
  ORDERS: '/my-account/orders',
  ORDER: '/complete-order',
  WISHLIST: '/my-account/wishlist',
  CONFIRM_ORDER: '/order/confirm',
  PUBLIC_ORDER: '/order/public',
  ABOUT_US: '/about-us',
  CONTACT_US: '/about-us?page=contact',
  STORE_POLICIES: '/about-us?page=store-policies',
  REDEEM_DIGITAL_PRODUCTS: (orderId: string) => `/order/${orderId}/redeem`,
}
